"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
var _reactBootstrap = require("react-bootstrap");
var _CardFooter = _interopRequireDefault(require("../../components/CardFooter"));
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _LoadableComponent = _interopRequireDefault(require("../../components/LoadableComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *  A react component to create a conditional step navigation
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A conditional step navigation
 */
function ConditionalNav(props) {
  var _props$rendering$fiel, _props$rendering$fiel3;
  var extractedFields, componentParam;
  var [currentSelection, setCurrentSelection] = (0, _react.useState)(null);
  var [currentLabel, setCurrentLabel] = (0, _react.useState)((_props$rendering$fiel = props.rendering.fields) === null || _props$rendering$fiel === void 0 || (_props$rendering$fiel = _props$rendering$fiel.DefaultStepTitle) === null || _props$rendering$fiel === void 0 ? void 0 : _props$rendering$fiel.value);
  var clickHandler = item => e => {
    setCurrentSelection(item);
    setCurrentLabel(item);
    if (item.itemOnClick) item.itemOnClick(e);
  };
  (0, _react.useEffect)(() => {
    var _props$rendering$fiel2;
    setCurrentLabel((_props$rendering$fiel2 = props.rendering.fields) === null || _props$rendering$fiel2 === void 0 || (_props$rendering$fiel2 = _props$rendering$fiel2.DefaultStepTitle) === null || _props$rendering$fiel2 === void 0 ? void 0 : _props$rendering$fiel2.value);
  }, [(_props$rendering$fiel3 = props.rendering.fields) === null || _props$rendering$fiel3 === void 0 || (_props$rendering$fiel3 = _props$rendering$fiel3.DefaultStepTitle) === null || _props$rendering$fiel3 === void 0 ? void 0 : _props$rendering$fiel3.value]);
  var titleDiv = (titleString, iconClass) => {
    if ((0, _lodash.isEmpty)(iconClass)) return titleString;else {
      return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(iconClass, " icon-lg col-12 mm-desktop-tablet-only")
      })), titleString);
    }
  };
  var TabContent = props => {
    if (props.IsContentDynamic.value) {
      if (!(0, _lodash.isEmpty)(props.ContentMainDynamic)) return /*#__PURE__*/_react.default.createElement(TabContentDynamic, props);else return null;
    } else return /*#__PURE__*/_react.default.createElement(TabContentStatic, props);
  };
  var TabContentDynamic = props => {
    var _props$ContentMainDyn, _props$ContentSideDyn;
    var showSideColumn = !(0, _lodash.isEmpty)(props.ContentSideDynamic);
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: showSideColumn ? 8 : 12
    }, /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
      name: (_props$ContentMainDyn = props.ContentMainDynamic.fields.ComponentName) === null || _props$ContentMainDyn === void 0 ? void 0 : _props$ContentMainDyn.value,
      rendering: props.ContentMainDynamic,
      params: componentParam,
      parentComponent: "conditionalnav"
    })), showSideColumn && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 4
    }, /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
      name: (_props$ContentSideDyn = props.ContentSideDynamic.fields.ComponentName) === null || _props$ContentSideDyn === void 0 ? void 0 : _props$ContentSideDyn.value,
      rendering: props.ContentSideDynamic,
      params: componentParam,
      parentComponent: "conditionalnav"
    })));
  };
  var TabContentStatic = props => {
    return (0, _richTextField.parseHTML)(props.ContentStatic);
  };
  if (props.rendering.fields) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    componentParam = props.params;
    var ShowHelpText = extractedFields => {
      var helpText = '';
      for (var i = 0; i < ((_extractedFields$Step = extractedFields.StepList) === null || _extractedFields$Step === void 0 ? void 0 : _extractedFields$Step.length); i++) {
        var _extractedFields$Step;
        if (extractedFields.StepList[i].fields.StepTitle.value === currentSelection) helpText = (0, _richTextField.parseHTML)(extractedFields.StepList[i].fields.HelpContent);
      }
      return helpText;
    };
    var ShowFooter = extractedFields => {
      return extractedFields.StepList.map((cta, index) => {
        var {
          linkUrl,
          linkTarget,
          linkAlt
        } = (0, _linkFieldSrc.linkFieldSrc)(cta.fields.Link.value);
        return cta.fields.StepTitle.value === currentSelection && /*#__PURE__*/_react.default.createElement(_CardFooter.default, {
          key: index,
          buttonType: cta.fields.ButtonType.value,
          linkUrl: linkUrl,
          linkTarget: linkTarget,
          linkAlt: linkAlt,
          buttonTxt: cta.fields.Text.value,
          ctaIcon: cta.fields.ctaIcon.value,
          ctaIconDirection: cta.fields.ctaIconPlacement.value,
          ctaDataId: cta.fields.ctaDataId.value
        });
      });
    };
    var ShowContent = extractedFields => {
      var getURLQuery = new URLSearchParams(props.params.pageQuery);
      var tabIndex = getURLQuery.get('tab');
      return extractedFields.StepList.map((listing, key) => {
        if (listing.fields.ContentOption.value === 'tabs') {
          return listing.fields.StepTitle.value === currentSelection && /*#__PURE__*/_react.default.createElement("div", {
            className: 'app-container',
            key: key,
            id: (0, _utils.getComponentContentId)(listing.id)
          }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs, {
            defaultKey: tabIndex === null || tabIndex > listing.fields.TabsContent.length - 1 || isNaN(tabIndex) ? '0' : tabIndex
          }, listing.fields.TabsContent.map((tabList, key) => {
            return listing.fields.StepTitle.value === currentSelection && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs.Tab, {
              eventKey: key,
              key: key,
              title: titleDiv(tabList.fields.Title.value, tabList.fields.Icon.value)
            }, /*#__PURE__*/_react.default.createElement(TabContent, tabList.fields));
          })));
        } else if (listing.fields.StepTitle.value !== extractedFields.DefaultStepTitle.value && listing.fields.ContentOption.value === 'static-content') {
          return listing.fields.StepTitle.value === currentSelection && /*#__PURE__*/_react.default.createElement("div", {
            className: "card card--basic",
            key: key,
            id: (0, _utils.getComponentContentId)(listing.id)
          }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(listing.fields.StaticContent))));
        } else return null;
      });
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "app-container",
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'card card--basic'
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, !(0, _lodash.isEmpty)(extractedFields.Title.value) && /*#__PURE__*/_react.default.createElement("div", {
      className: "h2"
    }, (0, _richTextField.parseHTML)(extractedFields.Title)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 8
    }, /*#__PURE__*/_react.default.createElement("p", null, extractedFields.StepText.value), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown, {
      id: "StepList_dropdown",
      type: "default",
      onClick: currentLabel.dropdownOnClick
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Toggle, {
      id: "StepList_toggle",
      label: currentLabel,
      type: "button"
    }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Menu, {
      id: "StepList_menu"
    }, extractedFields.StepList.map((titles, key) => {
      return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.DefaultItem, {
        eventKey: key,
        key: key,
        "data-testid": "select-element-test-id",
        onClick: clickHandler(titles.fields.StepTitle.value)
      }, titles.fields.StepTitle.value);
    })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 3
    }, currentLabel !== extractedFields.DefaultStepTitle.value ? /*#__PURE__*/_react.default.createElement(ShowHelpText, extractedFields) : '')), currentLabel !== extractedFields.DefaultStepTitle.value ? /*#__PURE__*/_react.default.createElement(ShowFooter, extractedFields) : '')), extractedFields.StepList.map(showRule => {
      if (showRule.fields.StepTitle.value === currentLabel && showRule.fields.ContentOption.value !== 'no-content') {
        return /*#__PURE__*/_react.default.createElement("hr", {
          style: {
            marginBottom: '3rem',
            marginTop: '3rem'
          }
        });
      } else return null;
    }), currentLabel !== extractedFields.DefaultStepTitle.value ? /*#__PURE__*/_react.default.createElement(ShowContent, extractedFields) : '');
  } else return null;
}
var _default = exports.default = ConditionalNav;